import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Plan } from '../models/plan';
import {
  DefaultEntityListStore,
  EntityListComponent,
  defaultEntityListStoreProvider,
} from '../util/entity-list/entity-list.base';
import { STORE_SERVICE_TOKEN } from '../util/store.service';
import { PlansService } from './plans.service';

@Component({
  selector: 'app-plans-chooser',
  templateUrl: './plans-chooser.component.html',
  styleUrls: ['./plans-chooser.component.scss'],
  providers: [defaultEntityListStoreProvider('plans-chooser.component')],
})
export class PlansChooserComponent
  extends EntityListComponent<Plan, {}>
  implements OnInit, OnDestroy
{
  // The active plan ID
  @Input()
  active: string;

  /** Matches `Plan.name` from the plans list; used to resolve the real plan id for checkout. */
  @Input()
  defaultPlanCode?: string;

  // Emits events when a plan is chosen
  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  select = new EventEmitter();

  // set pending to disabe all buttons
  @Input()
  pending = false;

  /** Plan IDs for which the "Additional usage" (pricing table) section is expanded. */
  expandedPlanIds = new Set<string>();

  constructor(
    plansService: PlansService,
    @Inject(STORE_SERVICE_TOKEN)
    store: DefaultEntityListStore
  ) {
    super(plansService, store);
  }

  getTableId(): string {
    return '';
  }

  handlePlanClick(plan: Plan) {
    this.select.emit(plan);
  }

  /** Plan whose `name` equals `default_plan_code` (same value org settings stores). */
  get resolvedDefaultPlan(): Plan | undefined {
    const code = this.defaultPlanCode;
    if (!code || !this.entityList.entities?.length) {
      return undefined;
    }
    return this.entityList.entities.find((p) => p.name === code);
  }

  handleDefaultPlanSubscribe(): void {
    const plan = this.resolvedDefaultPlan;
    if (plan) {
      this.handlePlanClick(plan);
    }
  }

  togglePricing(planId: string) {
    if (this.expandedPlanIds.has(planId)) {
      this.expandedPlanIds.delete(planId);
    } else {
      this.expandedPlanIds.add(planId);
    }
    this.expandedPlanIds = new Set(this.expandedPlanIds);
  }

  /** Delegates clicks on .pricing-label to toggle the pricing table. */
  onDescriptionClick(event: Event, planId: string) {
    if ((event.target as HTMLElement).closest('.pricing-label')) {
      this.togglePricing(planId);
    }
  }
}
